<template>

  <div class="card card-with-search border-0 card-with-shadow card-with-shadow-parent ">
    <div class="text-justify">
      <div class="row">
        <!-- <dynamic-form-preview v-bind:Id="id"></dynamic-form-preview> -->
        <div class="col-sm-12">
          <!-- pdf-orientation="landscape" -->
          <vue-html2pdf
              :showLayout=true
              :floatLayout=false
              :enableDownload=false
              :previewModal=true
              :pdfQuality=2
              pdfContentWidth="100%"
              :paginateElementsByHeight=880
              :manualPagination=false
              pdfFormat="a4"
              ref="html2Pdf"
              @hasDownloaded="onPdfComplete($event)"
              @startPagination="startPagination()"
          >
            <div slot="pdf-content" class="container-wrapper" ref="pdfSection">
              <div class="stacked-divs" id="print">
                <!-- Header -->
                <div class="position-relative form-header p-3">
                  <div class="row my-3 align-items-center container_btn" v-if="companyInfo != null">
                    <div class="col-lg-7 border-right col-md-12 col-sm-12">
                      <div
                          class="media align-items-center user-header-media"
                      >
                        <!--                        <app-avatar-->
                        <!--                          v-if="companyInfoCheck.checked_logo == true"-->
                        <!--                          :title="$t('avatars')"-->
                        <!--                          class="mr-4"-->
                        <!--                          avatar-class="avatars-w-70"-->
                        <!--                          :img="companyInfo.logo"-->
                        <!--                          :alt-text="$t('not_found')"-->
                        <!--                        />-->
                        <img v-if="companyInfoCheck.checked_logo == true" class="mr-4" :src="companyInfo.logo" alt="LOGO" height="auto" width="30%" />

                        <div class="media-body user-info-header">
                          <h6 class="mb-0 " >{{ companyInfoCheck.checked_company_name == true ? companyInfo.company_name : ''}} <span v-if="companyInfoCheck.checked_category_name == true">{{ ' ('+ companyInfo.category_name +')' }}</span></h6>
                          <p class="mt-2" v-if="companyInfoCheck.checked_company_number == true"> Reg No. {{ companyInfo.comapny_number }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-5 col-md-12 col-sm-12 mb-3">
                      <div>
                        <div class="media my-1" v-if="companyInfoCheck.checked_company_phone == true">
                          <div class="align-self-center mr-3">
                            <app-icon :name="'phone'" class="icon-size"/>
                          </div>
                          <div class="media-body">

                            <p class="mb-1">
                              {{ companyInfo.company_phone }}
                            </p>
                          </div>
                        </div>
                        <div class="media my-1" v-if="companyInfoCheck.checked_company_email == true">
                          <div class="align-self-center mr-3">
                            <app-icon :name="'mail'" class="icon-size"/>
                          </div>
                          <div class="media-body">
                            <p class="mb-1">
                              {{ companyInfo.company_email }}
                            </p>
                          </div>
                        </div>
                        <div class="media my-1" v-if="companyInfoCheck.checked_address == true">
                          <div class="align-self-center mr-3">
                            <app-icon :name="'map-pin'" class="icon-size"/>
                          </div>
                          <div class="media-body">

                            <p class="mb-1">
                              {{ companyInfo.address }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 text-center">
                      <p class="mb-2" v-if="companyInfoCheck.checked_description == true">
                        {{ companyInfo.description }}
                      </p>
                    </div>
                  </div>
                </div>
                <!-- Header Ends-->

                <div class="main__wrapper header-color-style formStyle form-inner-container p-3">


                <el-container>
                  <el-main :style="cssProps" >
                    <el-form class="formElements">
                      <template v-for="(eachFormObj, eachFormIndex) in forms">
<!--                        <div v-if="eachFormIndex > 0" class="html2pdf__page-break"/>-->

                        <el-col :span="24">
                          <el-checkbox v-model="eachFormObj.showSection">Check if applicable</el-checkbox>
                        </el-col>
                        <el-divider :key="`divider-${eachFormIndex}`" content-position="center">{{ eachFormObj.title }}</el-divider>
                        <el-row :key="`row-${eachFormIndex}`" v-show="getSectionView(eachFormIndex)">
                          <div class="wrapper--forms">
<!--                            <el-col :xs="24" :sm="24"-->
                            <el-col
                                    v-for="(field, index) in eachFormObj.fields"
                                    :key="index"
                                    :span="field.span"
                                    v-bind="field"
                                    class="form__group, position-relative pdf-item"
                                    :class="{'is---active':componentFieldId === field.componentId,}"
                                    >

                              <div @click="editElementProperties(field)">
                                <component :class="{'is---active':componentFieldId === field.componentId,}"
                                           :is="field.fieldType"
                                           :currentField="field"
                                           class="form__field"
                                           :style="field.componentValue == null && {border: 'solid 1px red',padding: '7px',}"
                                ></component>

                              </div>

                              <div class="form__actiongroup text-right"
                                   v-if="showStyleDiv == false && field.showComments"
                                   :style="hideOnPrint == true ? 'display:none' : 'display:block'">
                                <el-button-group
                                    class="form__actionlist hide_button"
                                    :class="{show_party:componentFieldId === field.componentId,}">
                                  <!--                                comment Icon    icon="el-icon-plus"-->
                                  <el-button size="mini" icon="el-icon-plus"
                                             @click="(event)=>cloneElementField(index,field,eachFormObj.fields, event)"
                                             v-show="!field.isUnique"
                                  ></el-button>
                                  <div class="comment-section" :id="'comment-container-'+field.componentId"
                                       ref="commentRefClick">
                                    <div class="message-input d-flex p-2 align-items-center">
                                      <input
                                          type="text"
                                          :v-bind-value="textComment[field.componentId]"
                                          class="form-control"
                                          placeholder="Type Comment"
                                          v-model="textComment[field.componentId]"
                                          v-on:keydown.enter.prevent="enter(textComment, field.componentId)"
                                      />
                                      <div class="message-input-append">
                                        <a
                                            href="#"
                                            class="btn btn-send p-2"
                                            @click.prevent="enter(textComment, field.componentId)"
                                        >
                                          <app-icon name="send" class="size-25"/>
                                        </a>

                                      </div>
                                    </div>
                                    <div class="card-body pb-0">
                                      <div class="row">
                                        <div class="col-sm-12">
                                          <div class="my-3 aqeel-class"
                                               v-for="(comm, commentIndex) in commentObject[field.componentId]"
                                               :key="commentIndex">
                                            <div class="d-flex" style="justify-content: space-between">
                                                    <span class="meta">
                                                      <app-media-object :media-title="comm.user"/>
                                                      <p>{{ comm.created_at | formatDate }}</p>
                                                    </span>

                                              <el-dropdown trigger="click">

                                                <el-button type="primary" class="btn btn-sm"
                                                           style="background: white;color: #4466f2;border: none;">
                                                  <app-icon name="more-vertical"
                                                            style="width: 10px !important;height: 10px !important;"/>
                                                </el-button>
                                                <el-dropdown-menu slot="dropdown">

                                                      </el-dropdown-menu>
                                                    </el-dropdown>
                                                  </div>
                                                  <p style="margin: 6px 0;border-bottom: 1px solid rgb(137 137 137 / 53%);">{{ comm.text }}</p>
                                                </div>
                                              </div>
                                            </div>

                                          </div>


                                    </div>
                                  </el-button-group>
                                </div>

                              </el-col>

                          </div>
                          </el-row>

                      </template>
                    </el-form>
                  </el-main>
                </el-container>

                <div class="row btn-border m-3 align-items-center" />
                <div style="display: flex; justify-content:space-between" class="ml-4 mr-4">
                  <p>
                    <small>Form ID: {{companyInfo.company_name && companyInfo.company_name.match(/\b(\w)/g).join('')+'C'+formInfo.id}}</small>
                  </p>
                  <p>
                    <small>Version: {{formInfo.version}}</small>
                  </p>
                </div>
              </div>
              </div>
            <div class="styling-block" v-if="showStyleDiv == true">
              <!-- For Form Styling Div -->

              <div class="col-12 collapse-title-size">
                <el-collapse v-model="activeName" accordion class="mt-3 border-top-none">
                  <!-- Header Setting -->
                  <el-collapse-item title="Header Setting" name="1">
                    <div class="row mb-2 p-2">
                      <div class="col-12 mb-2">
                        <h5>Select header content</h5>
                      </div>

                      <div class="col-6 mb-2">
                        <div class="form-group mb-0">
                          <app-input
                              type="single-checkbox"
                              :list-value-field="$t('logo')"
                              v-model="companyInfoCheck.checked_logo"
                          />
                        </div>
                        <div class="form-group mb-0">
                          <app-input
                              type="single-checkbox"
                              :list-value-field="$t('company_name')"
                              v-model="companyInfoCheck.checked_company_name"
                          />
                        </div>
                        <div class="form-group mb-0">
                          <app-input
                              type="single-checkbox"
                              :list-value-field="$t('company_number')"
                              v-model="companyInfoCheck.checked_company_number"
                          />
                        </div>
                        <div class="form-group mb-0">
                          <app-input
                              type="single-checkbox"
                              :list-value-field="$t('category_name')"
                              v-model="companyInfoCheck.checked_category_name"
                          />
                        </div>
                      </div>
                      <div class="col-6 mb-2">
                        <div class="form-group mb-0">
                          <app-input
                              type="single-checkbox"
                              :list-value-field="$t('company_email')"
                              v-model="companyInfoCheck.checked_company_email"
                          />
                        </div>
                        <div class="form-group mb-0">
                          <app-input
                              type="single-checkbox"
                              :list-value-field="$t('company_phone')"
                              v-model="companyInfoCheck.checked_company_phone"
                          />
                        </div>
                        <div class="form-group mb-0">
                          <app-input
                              type="single-checkbox"
                              :list-value-field="$t('address')"
                              v-model="companyInfoCheck.checked_address"
                          />
                        </div>
                        <div class="form-group mb-0">
                          <app-input
                              type="single-checkbox"
                              :list-value-field="$t('description')"
                              v-model="companyInfoCheck.checked_description"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="row mb-2 p-2">
                      <div class="col-12 mb-2">
                        <div class="row p-2">
                          <div class="col-6 p-2">
                            <label for="inputs_form_header_color" class="mb-0">{{ $t("Header background color") }}</label>
                            <input id="inputs_form_header_color" class="form-control" type="color" v-model="form_header_color"/>
                          </div>

                          <div class="col-6 p-2">
                            <label for="form_header_text_color" class="mb-0">{{ $t("Header text color") }}</label>
                            <input id="form_header_text_color" class="form-control" type="color" v-model="form_header_text_color"/>
                          </div>
                        </div>


                      </div>
                    </div>
                  </el-collapse-item>
                  <!-- Header Setting -->

                  <!-- Form Styling -->
                  <el-collapse-item title="Form Designer" name="2">
                    <div class="row mb-2 p-2">
                      <div class="col-12">
                        <h5>Select your Theme</h5>
                      </div>
                    </div>
                    <div class="row mb-3 p-2">
                      <div class="col-3">
                        <div class="box-01">
                          <p class="box-text-color" @click.prevent="changeColor(1)">A</p>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="box-02">
                          <p class="box-text-color" @click.prevent="changeColor(2)">A</p>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="box-03">
                          <p class="box-text-color" @click.prevent="changeColor(3)">A</p>
                        </div>
                      </div>
                      <div class="col-3">
                        <div class="box-04">
                          <p class="box-text-color" @click.prevent="changeColor(4)">A</p>
                        </div>
                      </div>
                    </div>
                    <div class="row mb-5 p-2">
                      <div class="col-6">
                        <label for="inputs_form_color" class="mb-0">{{ $t("form_color") }}</label>
                        <input id="inputs_form_color" class="form-control" type="color" v-model="form_color"/>
                      </div>
                      <!-- <div class="col-6">
                        <label for="inputs_form_border_color" class="mb-0">{{ $t("form_border_color") }}</label>
                        <input
                            id="inputs_form__border_color"
                            class="form-control"
                            type="color"
                            v-model="form_border_color"
                        />
                      </div> -->
                    </div>
                    <div class="row mb-5 p-2">
                      <div class="col-6 mt-2">
                        <label for="inputs_font_color" class="mb-0">{{ $t("font_color") }}</label>
                        <input id="inputs_font_color" class="form-control" type="color" v-model="font_color"/>
                      </div>
                      <!-- <div class="col-6 mt-5">
                        <label for="inputs_input_back_color" class="mb-0">
                          {{ $t("input_back_color") }}
                        </label>
                        <input id="inputs_input_back_color"
                          class="form-control"
                          type="color"
                          v-model="inputs.input_back_color">
                      </div>-->
                    </div>
                  </el-collapse-item>
                  <!-- Form Styling -->
                </el-collapse>
                <div class="row">
                  <div class="col-12 mt-5" style="display:flex; justify-content:space-between">
                    <button
                        type="button"
                        class="btn btn-primary"
                        data-dismiss="modal"
                        @click.prevent="previous"
                    >{{ $t("Previous") }}
                    </button>
                    <!-- </div>
                    <div class="col-6 mt-5">-->
                    <button
                        type="button"
                        class="btn btn-success"
                        @click.prevent="saveStyling"
                    >{{ $t("Save Styling") }}
                    </button>
                  </div>
                </div>
              </div>

              <!-- For Form Styling Div -->
            </div>
            </div>

          </vue-html2pdf>

          <div class="my-3 mx-auto text-center d-flex" v-if="isLock === 'no'">
<!--            Adding Logic for not showing submit button when form is submitted and approved-->
            <div v-if="is_shareResponse === false">
                <div v-if="(showFormActions('assigneAccess','save_response') || this.response === 'save_response') && this.responseStatus !== 'approved'">
                  <el-button
                      v-if="formStatus !== 'submitted' || formStatus !== 'pending'"
                      type="primary"
                      @click="saveForm('draft')"
                      class="m-1"
                  >Save as Draft
                  </el-button>


                  <el-button v-if="invoice_Status === 'succeeded' && formStatus !== 'pending'"
                            class="my-1"
                            type="success"
                            @click="saveForm('submitted')"
                  >Save & Submit
                  </el-button>
                </div>
                <div v-if="showFormActions('ownerAccess', 'status_response') || showFormActions('auditorAccess', 'status_response')">
                  <el-button
                      v-if=" formStatus !== 'pending'"
                      class="m-1"
                      type="danger"
                      @click="taskAudit('rejected')"
                  >Reject
                  </el-button>
                  <el-button
                      v-if="response == null && formStatus !== 'pending'"
                      class="m-1"
                      type="danger"
                      @click="taskAudit('approved')"
                  >Approve
                  </el-button>
                </div>
              <!--            <button @click.prevent="generateReport" class="btn btn-primary">Print</button>-->

              <!-- <el-button
                      style="margin-bottom: 10px"
                      type="primary"
                      @click="print()"
                      >Print</el-button
              >-->
              <!--          <div class="ml-5 form-inner-container">-->


                <app-input class="m-3"
                           type="radio-buttons"
                           :list="updateStrategyList"
                           v-model="isUpdateStrategy"/>

              <ShareResponse/>
            </div>
            <el-button
                type="info"
                @click.prevent="generateReport">Print</el-button>
            <el-button v-if="showBackButton" type="primary" @click.prevent="backToList" class="m-1">
              Back
            </el-button>   <!--          </div>-->
          </div>

          <div class="text-center" v-if="isLock === 'yes'">
            <el-button
                type="warning"
                @click="saveForm('draft')"
                class="m-1"
            >Lock Response
            </el-button>
          </div>

        </div>

      </div>
    </div>
    <!--Delete Modal-->
    <app-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="task-delete"
      @confirmed="confirmed"
      @cancelled="canceled"
    />

  </div>

</template>

<script>
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { FormMixin } from "@/core/mixins/form/FormMixin";
import { FormBuilder } from "../../CustomFormBuilder/form_elements/formbuilder";
import { axiosGet, axiosPost } from "@/app/Helpers/AxiosHelper";
import VueHtml2pdf from 'vue-html2pdf'
import {
  TASK_ASSIGN_FORM_SHOW,
  FORM_BUILDER_RESPONSE_POST,
  FORM_INPUT_COMMENT_STORE,
  FORM_INPUT_COMMENT_LIST,
  FORM_INPUT_COMMENT_DELETE,
  FORM_INPUT_COMMENT_UPDATE,
  COMPANY_INVOICE_SATUS,
  TASK_AUDIT,
  BODY_STYLE_UPDATE,
  SHARE_RESPONSE_VIEW,
  LOCK_FORM_BUILDER_RESPONSE_POST
} from "@/app/Config/ApiUrl";
import ShareResponse from "@Views/SuperAdmin/Task/Form/ShareResponse";

export default {
  name: "FormPreview",

  components: {
    ...FormBuilder.$options.components,
    VueHtml2pdf,
    ShareResponse
  },
  mixins: [ModalMixin, FormMixin],
  props: {
    new_tab: String,
    lock: String,
    id: {type:[String,Number], required: true},
    // taskId: {type:[String,Number], required: true},
    form_id:  {type:Number, required: true},
    form_revision_id: {type:Number, required: true},
    type: {type:String },
    showStyleDiv: Boolean,
    backList: Function,
    // userId: {type:[Number, String]},
    response: String,
    back: Function,
    hidePrevious: String,
    formType: String,
    data:{},
  },
  data() {
    return {
      updateStrategyList: [
        {
          id: 'update',
          value: 'Update Existing'
        },{
          id: 'create',
          value: 'Create New'
        },],
      isUpdateStrategy: 'create',
      is_shareResponse: this.$props.data?.shareResponse ?? false,
      isNewTab: this.new_tab ?? 'no',
      isLock: this.lock ?? 'no',
      isActive: false,
      responseStatus: '',
      // flag: null,
      // formDesign: this.$store.state.formdesigner.formstyling,
      savedFormBodyStyle:[],
      activeName: 1,
      companyInfoCheck: {
          checked_company_name: false,
          checked_logo: false,
          checked_company_number: false,
          checked_company_email: false,
          checked_company_phone: false,
          checked_address: false,
          checked_description: false,
          checked_category_name: false,
        },
      formStatus: '',
      hideOnPrint:false,
      formInfo: {},
      on_select: false,
      form_color: "",
      form_header_color: "",
      form_header_text_color: "",
      font_color: "",
      select_color: [{
        form_header_color: this.form_header_color,
        form_header_text_color: this.form_header_text_color,
        form_color: this.form_color,
        font_color: this.font_color,
      }],
      // form_border_color: "",
      root: null,
      // accentColor: '#000',
      view_type: "",
      companyInfo: {},
      user_id: "",
      invoice_Status: "succeeded",
      remove_id: "",
      deleteConfirmationModalActive: false,
      uploadFilePathfinal: {},
      fieldId: [],
      textCommentId: 0,
      commentRequest: {},
      textComment: {},
      created_by: 0,
      task_id: "",
      form_body_id: 0,
      forms: this.$store.state.formBuilder.forms,
      commentObject: {},
      commentText: "",
      componentFieldId: 0,
      themingVars: this.$store.state.formBuilder.themingVars,
      preloader: false,
      showComments: false,
      inputs: {
        yes: "no"
      },
      // status:'',
      modalId: "form-view-Modal",
      modalTitle: this.$t("add"),
      color_data: [
        {
          theme_no: 1,
          form_color: "#F0FCFF",
          // form_border_color: "#83D0E4",
          font_color: "#264B67"
        },
        {
          theme_no: 2,
          form_color: "#FFDF79",
          // form_border_color: "#FB6F41",
          font_color: "#6A1B00"
        },
        {
          theme_no: 3,
          form_color: "#EFE8D4",
          // form_border_color: "#5A4B44",
          font_color: "#321F16"
        },
        {
          theme_no: 4,
          form_color: "#E4EFFF",
          // form_border_color: "#2462B9",
          font_color: "#12458D"
        }
      ]
    };
  },
  methods: {
    getSectionView(eachFormIndex){
      const applicable = this.forms[eachFormIndex].showSection;
      return applicable !== undefined ? applicable : true;
    },
    showFormActions(param, status){

      var showAction = this.$store.state.sharedData.sharedData?.showFormActions;
      if (showAction != null) {
          if (param === 'assigneAccess') {
            return showAction.assigneAccess;
          }
          else if (param === 'auditorAccess') {
            return showAction.auditorAccess;
          }
          else if (param === 'ownerAccess') {
            return showAction.ownerAccess;
          }
      }
      else {
          return status === 'save_response' ? true : false;
      }
    },

    // Function to check height and add page breaks
    checkAndAddPageBreak() {
      // Get the content wrapper element
      const contentWrapper = this.$el.querySelector('.wrapper--forms');

      // Get the inner elements within the content wrapper
      const innerElements = contentWrapper.children;

      // Initialize the height counter and page break count
      let totalHeight = 0;
      let pageBreakCount = 0;
      // Flag to check if it's the first page
      let isFirstPage = true;

      // Loop through each inner element and calculate the total height
      for (let i = 0; i < innerElements.length; i++) {
        if (isFirstPage) {
          totalHeight += 120; // Adjust this function to get the actual header height
          isFirstPage = false;
        }
        totalHeight += innerElements[i].offsetHeight;

        // Check if the height has reached a multiple of 1000px
        if (totalHeight >= (pageBreakCount + 1) * 1000) {
         // Insert a div with class "html2pdf__page-break" after the current inner element
          const pageBreakDiv = document.createElement('div');
          pageBreakDiv.className = 'html2pdf__page-break';
          innerElements[i].insertAdjacentElement('afterend', pageBreakDiv);
          pageBreakCount++;
        }
      }
    },
    backToList() {
      this.back();
    },
    changeColor(num) {
      
      this.on_select = true;
      this.select_color = this.color_data.filter(data => {
        return data.theme_no === num;
      });
      this.root.style.setProperty(
        "--form-color",
        this.select_color[0].form_color
      );
      this.root.style.setProperty(
        "--form-header-color",
        this.select_color[0].form_header_color
      );
      this.root.style.setProperty(
        "--form-header-text-color",
        this.select_color[0].form_header_text_color
      );
      // this.root.style.setProperty(
      //   "--form-border-color",
      //   this.select_color[0].form_border_color
      // );
      this.root.style.setProperty(
        "--font-color",
        this.select_color[0].font_color
      );
      //  
    },
    async beforeDownload ({ html2pdf, options, pdfContent }) {

      html2pdf().set({
        pageBreak: { mode: 'avoid-all', before: '#page2el' }
      });
      await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages()
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i)
          pdf.setFontSize(10)
          pdf.setTextColor(150)
          pdf.text('Page ' + i + ' of ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
        }
      }).save()
    },


    async startPagination () {
      this.$toastr.s("Printing task initiated in the background, Please wait...");
    },
    async onPdfComplete(){
      this.$toastr.s("Printing task finished.");
      this.$hub.$emit('setParagraphContentLength', {
        maxCharacters: 200,
      });
      this.$hub.$emit('printInProgress', {
        status: false,
      });
      this.setDefaultColor()
    },

    async generateReport() {
      this.$hub.$emit('setParagraphContentLength', {
        maxCharacters: Infinity,
      });
      this.$hub.$emit('printInProgress', {
        status: true,
      });
      this.setFormColor();
      this.checkAndAddPageBreak();
      this.hideOnPrint = true;
      this.$refs.html2Pdf.generatePdf();

    },

    previous() {
      if (this.formType && this.formType === 'import_body_styling') {
            this.$store.commit('deleteSharedData',"showFormActions");
          this.back();
      }
      else {
        this.$emit(" ", 1);
      }
    },
    saveStyling() {
      
        // console.log(this.companyInfoCheck);
      // if(this.on_select == true){
      let bodyStyling = JSON.stringify(this.select_color);
      let headerContent = JSON.stringify(this.companyInfoCheck)
      if (this.formType && this.formType === 'import_body_styling') {
          this.$emit('styling',bodyStyling, headerContent);
      }
      else {
        axiosPost(BODY_STYLE_UPDATE, {
          bodyStyling: bodyStyling,
          headerContent: headerContent,
          form_body_id: this.id
        }).then(res => {
            this.$toastr.s(res.data.message);
            this.backList();
            this.select_color = [];
          }).catch(res => {
          console.error(res)
          });
        // }else{
        //     this.$toastr.s("Form save without styling");
        //     this.backList();
        // }

      }
    },
    removeFileAction(fileid) {
      this.remove_id = fileid;
      this.deleteConfirmationModalActive = true;
      // this.$store.state.uploadFilePath.dataUploadFilePath.splice(fileid , 1);
    },
    canceled() {
      this.remove_id = "";
      this.deleteConfirmationModalActive = false;
    },
    confirmed() {
      this.$store.state.uploadFilePath.dataUploadFilePath.splice(
        this.remove_id,
        1
      );

      this.hideDeleteModal();
    },
    hideDeleteModal() {
      this.deleteLoader = false;
      $("#task-delete").modal("hide");
      this.canceled();
    },
     getData() {// let form_id = this.getQueryParam();
      /**
       * * Pass the value to server, so that we can get required form response,
       * */

      let url;
      if(this.is_shareResponse === true) {
        url = `${SHARE_RESPONSE_VIEW}/${this.$props.data.link}`;
      }
      else {
        if (typeof this.taskId == "undefined") {
          if(this.response === "save_response" || this.response == 'save-response-view') {
            url = `${TASK_ASSIGN_FORM_SHOW}/${this.$props.id}?form_id=${this.$props.form_id}&form_revision_id=${this.$props.form_revision_id}&type=${this.$props.response}&user_id=${this.$props.data?.user_id??this.$props.userId}&batch=${this.$store.state.sharedData.sharedData?.guestFormData?.batch}`;
          }
          else {
            url = `${TASK_ASSIGN_FORM_SHOW}/${this.$props.id}?form_id=${this.$props.form_id}&task_id=${this.$props.taskId??''}&form_revision_id=${this.$props.form_revision_id??''}&type=${this.$props.response}&user_id=${this.$store.state.sharedData?.sharedData?.guestFormData?.user_id}&guest=${this.$store.state.sharedData.sharedData?.guestFormData?.guest} &batch=${this.$store.state.sharedData.sharedData?.guestFormData?.batch}`;

            // url = `${TASK_ASSIGN_FORM_SHOW}/${this.id}?type=view`;
          }
        } else if(typeof this.userId != "undefined") {
          url = `${TASK_ASSIGN_FORM_SHOW}/${this.$props.id}?task_id=${this.$props.taskId??this.$attrs.taskId??this.$props.data?.task_id}&form_id=${this.$props.form_id}&form_revision_id=${this.form_revision_id}&user_id=${this.$props.data?.user_id??this.$store.state.sharedData.sharedData?.guestFormData?.user_id}&guest=${this.$store.state.sharedData.sharedData?.guestFormData?.guest} &batch=${this.$store.state.sharedData.sharedData?.guestFormData?.batch}`;
        }
        else{
          url = `${TASK_ASSIGN_FORM_SHOW}/${this.id}?task_id=${this.taskId}&form_id=${this.form_id}&form_revision_id=${this.form_revision_id}`;
        }
      }
      this.$store.commit('updateSharedData', {index: "formPreviewUrl", newValue: url})
      axiosGet(url)
        .then(res => {
          if (res.data.length !== 0) {
            // this.forms = res.data.body;
            this.forms = res.data.body.map(form => ({
                ...form,
                showSection: form.hasOwnProperty('showSection') ? form.showSection : true
              }));

            this.form_body_id = res.data.id;
            // this.form_id = res.data.form_id;
            this.user_id = res.data.user_id;
            this.companyInfo = res.data.companyInfo;
            this.view_type = res.data.view_type;
            this.formInfo = res.data.form_revision;
            this.created_by = res.data.form_revision.created_by;
            this.companyInfoCheck = JSON.parse(res.data.header_content);
            this.formStatus = res.data.status;
            this.responseStatus = res.data.response_status;

            let data = JSON.parse(res.data.bodyStyle);
            this.savedFormBodyStyle = data
            
            // this.changeColor(data[0].theme_no);
            if (data && data.length > 0) {
              this.root.style.setProperty("--form-color", data[0].form_color);
              this.root.style.setProperty("--font-color", data[0].font_color);
              this.root.style.setProperty("--form-header-color", data[0].form_header_color??'#fff');
              this.root.style.setProperty("--form-header-text-color", data[0].form_header_text_color??'#000000');

            } else {
              this.root.style.setProperty("--form-color", "#fff");
              // this.root.style.setProperty("--form-border-color", "#898989");
              this.root.style.setProperty("--font-color", "#000");
            }

            // if (res.data.status == 2) {
            //   this.status = res.data.status;
            // }
            
            this.getInputsComments();
          }
        })
        .catch(res => {
          this.$toastr.e(res.response.data.message);
          this.$toastr.e('Closing in 3 sec...');
          setTimeout(function() {
            window.close();
          }, 3000);
        });
    },
    saveForm(status) {
      // if(this.status)
      // {
      //   this.status = 2;
      // }
      // this.$attrs['currentField'].uploadURL = this.$store.state.uploadFilePath.dataUploadFilePath ;
      let formData = [];
      for (let formObj of this.forms) {
        let fieldCount = 0;
        for (let obj of formObj.fields) {
          if (
              obj.fieldType === "TextInput" ||
              obj.fieldType === "LongTextInput" ||
              obj.fieldType === "NumberInput" ||
              obj.fieldType === "SelectList" ||
              obj.fieldType === "RadioButton" ||
              obj.fieldType === "Checkbox" ||
              obj.fieldType === "TimePicker" ||
              obj.fieldType === "DatePicker" ||
              obj.fieldType === "DatetimePicker" ||
              obj.fieldType === "Rating" ||
              obj.fieldType === "Upload" ||
              obj.fieldType === "UploadMediaFile" ||
              obj.fieldType === "Instruction" ||
              obj.fieldType === "TableComponent" ||
              obj.fieldType === "SignaturePad" ||
              obj.fieldType === "Name" ||
              obj.fieldType === "Address" ||
              obj.fieldType === "Email" ||
              obj.fieldType === "Phone" ||
              obj.fieldType === "elswitch"
          ) {
            formData.push({
              index: obj.componentId,
              value: obj.componentValue,
              form_id: this.form_id,
              form_revision_id: this.form_revision_id,
              type: obj.fieldType,
              task_id: this.taskId ?? 0,
              is_lock_response: obj.is_lock_response ?? null,
            });
          }
          fieldCount++;
        }
      }
      //  console.log('FORM RESPONSE', formData);
      let url = this.isLock === 'no' ? FORM_BUILDER_RESPONSE_POST : LOCK_FORM_BUILDER_RESPONSE_POST;
      axiosPost(url, {
        data: formData,
        id: this.form_body_id,
        task_id: this.taskId ?? 0,
        form_revision_id: this.form_revision_id,
        form_status: status,
        type: this.type,
        batch: this.$store.state.sharedData.sharedData?.guestFormData?.batch,
        saveStrategy: this.isUpdateStrategy,
      })
        .then(res => {
          this.$toastr.s(res.data.message);

          if (this.isNewTab === 'yes' || this.isLock === 'yes') {
            setTimeout(function() {
                window.close();
            }, 2000);
          }
          else {
            this.back();
          }
          // console.info(res);
        })
        .catch(res => {
          console.error(res);
        });
    },
    getQueryParam() {
      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      return params.get("form_id");
    },
    // deleteElement(index, form) {
    //   FormBuilder.deleteElement(index, form);
    // },
    cloneElementField(index, field, form, event) {

      this.field_id = field.componentId;
      const user = this.userRole.full_name;
      const val = [{ user: user }];
      this.commentObject[this.field_id]
        ? this.commentObject[this.field_id].push({ user: user })
        : this.$set(this.commentObject, this.field_id, val);

      let commentElement = document.getElementById('comment-container-'+field.componentId)
      commentElement.classList.toggle('active-field-comment')
    },
    editElementProperties(fields) {
      
      this.commentText = fields.componentId;
      this.componentFieldId = fields.componentId;

      var element = this.$refs[fields.componentId];

      if (element) {
        if (element.classList.contains("is---active")) {
          element
            .getElementsByClassName("is---active")[0]
            .scrollIntoView({ behavior: "smooth", block: "end" });
        }
      }
    },
    focusInput(i) {
      // alert(i);

      this.componentFieldId = i;
    },
    enter(textComment, i) {
      this.commentRequest.comment = textComment[i];
      this.commentRequest.component_id = this.componentFieldId;
      this.commentRequest.form_body_id = this.form_body_id;
      this.commentRequest.text_id = this.textCommentId;
      this.commentRequest.task_id = this.taskId;

      if (this.textCommentId !== 0) {
        
        axiosPost(FORM_INPUT_COMMENT_UPDATE, this.commentRequest)
          .then(res => {
            this.$toastr.s(res.data.message);
          })
          .catch(res => {
            this.$toastr.e(res.data.error);
          })
          .finally(() => {
            this.$set(this.textComment, i, "");
            this.textCommentId = 0;
            this.getInputsComments();
          });
      } else {
        
        textComment[i]
          ? axiosPost(FORM_INPUT_COMMENT_STORE, this.commentRequest)
              .then(res => {
                this.$toastr.s(res.data.message);
              })
              .catch(res => {
                this.$toastr.e(res.data.error);
              })
              .finally(() => {
                this.$set(this.textComment, i, "");
                this.getInputsComments();
              })
          : this.$toastr.e("Please fill comment box ");
      }
    },
    editComment(commentIndex, i, comm) {
      this.$set(this.textComment, i, comm.text);
      this.textCommentId = comm.text_id;

      
      if (this.textComment !== null) {
        this.reloadfun(i);
        this.focusInput(i);
      }
    },
    deleteComment(commentIndex, i, id) {
      axiosGet(FORM_INPUT_COMMENT_DELETE + "/" + id)
        .then(res => {
          this.$toastr.s(res.data.message);
        })
        .catch(res => {
          console.error(res);
        })
        .finally(() => {
          this.getInputsComments();
        });
    },
    reloadfun(i) {
      //
      return this.textComment[i];
    },
    setDefaultColor(){
      this.root.style.setProperty("--form-color", this.savedFormBodyStyle[0].form_color);
      this.root.style.setProperty("--font-color", this.savedFormBodyStyle[0].font_color);
      this.root.style.setProperty("--form-header-color", this.savedFormBodyStyle[0].form_header_color??'#fff');
      this.root.style.setProperty("--form-header-text-color", this.savedFormBodyStyle[0].form_header_text_color??'#000000');
    },
    setFormColor(){
      this.root.style.setProperty("--form-color",'#ffffff');
      this.root.style.setProperty("--form-header-color",'#ffffff');
      this.root.style.setProperty("--form-header-text-color",'#00000');
      this.root.style.setProperty("--font-color",'#00000');
    },
    getInputsComments() {
      axiosGet(
        FORM_INPUT_COMMENT_LIST +
          "/" +
          this.form_body_id +
          "?task_id=" +
          this.taskId
      )
        .then(res => {
          if (res.data.length !== 0) {
            this.commentObject = res.data;
          }
        })
        .catch(res => {
          console.error(res);
        });
    },
    invoiceStatus() {
      let id = this.userRole.company_id;
      axiosGet(COMPANY_INVOICE_SATUS + "/" + id)
        .then(res => {
          this.invoice_Status = res.data;
        })
        .catch(res => {
          console.error(res);
        });
    },
    taskAudit(status) {
      let data = {
        status: status,
        form_revision_id: this.form_revision_id,
        task_id: this.taskId,
        user_id: this.user_id,
      };
      
      // let form_revision_id = this.form_revision_id;
      // let task_id = this.taskId;
      let url = TASK_AUDIT;
      axiosPost(url, data)
        .then(response => {
          this.$toastr.s(response.data.message);
        })
        .catch(res => {
          console.error(res);
        });
    },
  },
  created() {
    // this.$store.state.inputMode.type = !this.$store.state.inputMode.type;
  },
  watch: {
    form_header_color(){
      this.root.style.setProperty("--form-header-color", this.form_header_color);
      this.select_color[0].form_header_color = this.form_header_color;
      // this.select_color[0] = { form_header_color: this.form_header_color };
      // this.select_color.unshift({ form_header_color: this.form_header_color });

    },
    form_header_text_color(){
      this.root.style.setProperty("--form-header-text-color", this.form_header_text_color);
      // this.select_color[0].form_header_text_color = this.form_header_text_color;
      // this.select_color[0] = { form_header_text_color: this.form_header_text_color };
      this.select_color[0].form_header_text_color = this.form_header_text_color;

    },
    form_color() {
      // this.$store.state.formdesigner.formstyling = {
      //   form_color: this.form_color,
      //   form_border_color: this.form_border_color,
      //   font_color: this.font_color,

      // };
      // const form_colortest = this.form_color;
      this.root.style.setProperty("--form-color", this.form_color);
      this.select_color[0].form_color = this.form_color;



      // this.select_color[0].form_color = this.form_color;
    },
    form_border_color() {
      // this.$store.state.formdesigner.formstyling.form_border_color = this.form_border_color;
      this.root.style.setProperty(
        "--form-border-color",
        this.form_border_color
      );
      this.select_color[0].form_border_color = this.form_border_color;
    },
    font_color() {
      // this.$store.state.formdesigner.formstyling.font_color = this.font_color;
      this.root.style.setProperty("--font-color", this.font_color);
      this.select_color[0].font_color = this.font_color;
    },
  },

  computed: {
    showBackButton(){
      return this.$store.state.sharedData.sharedData?.showBackButton??false;
    },
    
    taskId(){
       return this.data?.task_id?? this.$store.state.sharedData.sharedData.taskId;
    },
    userId(){
      return this.data?.user_id?? this.$store.state.sharedData.sharedData.guestFormData.id;
    },
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
    filePath() {
      return this.$store.state.uploadFilePath.dataUploadFilePath;
      //  this.$store.dispatch("setValueToPass", documents);
    },
    cssProps() {
      // Return an object that will generate css properties key
      // to match with the themingVars
      //
      // Example output: { '--theme-primary-color': this.themingVars.primaryColor }
      var result = {},
        themingVars = this.themingVars;

      for (var v in themingVars) {
        if (themingVars.hasOwnProperty(v)) {
          var newV = "--theme-" + _.kebabCase(v),
            suffix = "";

          // Add px to the value if the default value contain 'px'
          if (_.includes(newV, "size")) suffix = "px";
          else if (_.includes(newV, "margin")) suffix = "px";
          else if (_.includes(newV, "radius")) suffix = "px";

          result[newV] = themingVars[v] + suffix;
        }
      }
      return result;
    },

  },
  mounted() {
    this.getData();
    $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    this.$store.state.inputMode.type = false;
    // this.invoiceStatus();
    this.root = document.documentElement;
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkSectionHeight);
  },

};
</script>